<!-- (2) if interlocutor is blocked - add class "chat__insertion--blocked" -->
<div #wrapChatMsg class="chat__bottom">
  <!-- reserved-product info -->
  <!-- <div *ngIf="isReserved && !reservation?.reservedToMe" class="chat__reservedItem">
    <p class="vc-text-m" i18n="@@CHAT.CONTENT.ITEM.RESERVED">Your item is reserved by premium member</p>
    <p class="vc-text-m chat__reservedItem__info" i18n="@@CHAT.FORM.NO.NEGOCIATION">
      You cannot negotiate for the moment
    </p>
  </div> -->
  <div
    class="chat__insertion"
    [ngClass]="{
      'chat__insertion--exceed': currentMessage.length >= limitCharacter,
      'chat__insertion--blocked': receiverIsBlocked || senderIsBlocked || receiverIsBanned || senderIsBanned
    }"
  >
    <p class="chat__insertion__error vc-text-xs" i18n="@@CHAT.FORM.MSG_EXCEED">
      Message exceeds {{ limitCharacter }} characters
    </p>
    <textarea
      #chatMsg
      *ngIf="!senderIsBlocked || !senderIsBanned || !receiverIsBlocked || !receiverIsBanned"
      ngModel
      name="message"
      class="chat__insertion__msg vc-text-m"
      placeholder="Write a message"
      i18n-placeholder="@@CHAT.FORM.PLACEHOLDER_WRITE"
      rows="1"
      [maxlength]="limitCharacter"
      (ngModelChange)="adjustToContent()"
      [(ngModel)]="currentMessage"
    ></textarea>
    <button
      *ngIf="!senderIsBlocked || !senderIsBanned || !receiverIsBlocked || !receiverIsBanned"
      type="submit"
      class="chat__insertion__send"
      [disabled]="currentMessage.length >= limitCharacter || currentMessage.length === 0"
      (click)="onSubmit()"
    >
      <vc-sprite-icons name="send" class="chat__insertion__send__svg"></vc-sprite-icons>
    </button>
    <!-- **** blocking warning **** -->
    <div *ngIf="receiverIsBlocked" class="chat__insertion__isBlocked vc-text-m">
      <p *ngIf="receiverInfo?.username" i18n="@@CHAT.FORM.INTERLOCUTOR_BLOCKED">
        You blocked {{ receiverInfo.username }}
      </p>
      <p class="chat__insertion__isBlocked__info" i18n="@@CHAT.FORM.INTERLOCUTOR_BLOCKED.CSQ">
        You cannot send a message
      </p>
    </div>
    <div *ngIf="senderIsBlocked" class="chat__insertion__isBlocked vc-text-m">
      <p *ngIf="receiverInfo?.username" i18n="@@CHAT.FORM.YOURSELF_BLOCKED">
        You've been blocked by {{ receiverInfo.username }}
      </p>
      <p class="chat__insertion__isBlocked__info" i18n="@@CHAT.FORM.YOURSELF_BLOCKED.CSQ">You cannot send a message</p>
    </div>
    <!-- **** banning warning **** -->
    <div *ngIf="receiverIsBanned" class="chat__insertion__isBlocked vc-text-m">
      <p *ngIf="receiverInfo?.username" i18n="@@CHAT.FORM.INTERLOCUTOR_BANNED">
        {{ receiverInfo.username }} is no longer able to receive messages
      </p>
      <p class="chat__insertion__isBlocked__info" i18n="@@CHAT.FORM.INTERLOCUTOR_BANNED.CSQ">
        You cannot send a message.
      </p>
    </div>
    <a
      href="https://faq.vestiairecollective.com/hc/en-us/articles/360011181318-Why-have-I-been-banned-"
      i18n-href="@@CHAT.FORM.YOURSELF_BANNED.FAQ"
      *ngIf="senderIsBanned"
      class="chat__insertion__isBlocked vc-text-m"
    >
      <p i18n="@@CHAT.FORM.YOURSELF_BANNED">You've been banned from the chat.</p>
      <p class="chat__insertion__isBlocked__info" i18n="@@CHAT.FORM.YOURSELF_BANNED.CSQ">
        Read more about ban.
      </p>
    </a>
  </div>
</div>
